module.exports = __webpack_public_path__ + "static/img/1_1_2_4.0c2c8d75.jpg";